import { getIntlDateTimeFormat } from './get-intl-date-time-format';
import { getValueForDateProperty } from './get-value-for-date-property';
/**
 * Gets a localised date property based on the request options.
 * @hidden
 */
export const getLocalisedDateProperty = (request) => {
    const { date, languageTag, ianaTimeZoneName, property, format, hour12 } = request;
    const prop = property === 'dayPeriod' ? 'hour' : property;
    const options = {
        languageTag: languageTag,
        [prop]: format,
        timeZone: ianaTimeZoneName,
        hour12: hour12 !== false || property === 'dayPeriod'
    };
    const parts = getIntlDateTimeFormat(options).formatToParts(date);
    return getValueForDateProperty(parts, property);
};
//# sourceMappingURL=get-localised-date-property.js.map